import { useCallback, useSyncExternalStore } from 'react';

/**
 * Below Tailwind `md` (768px): the phone layout (#2680).
 *
 * The kit's own copy of the host's phone breakpoint. "Is this a phone" is a
 * browser fact, not host data or policy, so it takes no seam (ADR-0035 D3);
 * and the kit may not import the host, so it cannot reuse the host hook. A
 * host test pins the two queries equal.
 */
export const KIT_PHONE_MEDIA_QUERY = '(max-width: 767px)';

function mediaQueryList(): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(KIT_PHONE_MEDIA_QUERY)
    : null;
}

/**
 * Whether the viewport is a phone now, re-rendering the caller when that
 * changes. Without `window.matchMedia` (jsdom) it is constantly false.
 */
export function useKitIsPhone(): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const list = mediaQueryList();
    if (list === null) return () => {};
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, []);
  const getSnapshot = () => mediaQueryList()?.matches ?? false;
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
